import { api } from '../rtk';
import { ENDPOINTS } from '../url';

export const showroomApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getShowrooms: builder.query({
            query: ({ search, page, limit = 10 }) => ({
                url: ENDPOINTS.SHOWROOMS,
                method: 'GET',
                params: { search, page, limit },
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Showrooms'],
        }),
        getShowroomById: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.SHOWROOMS}${id}`,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
            providesTags: ['Showrooms'],
        }),
        updateShowroom: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.SHOWROOMS}${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    'x-portal': 'admin'
                }
            }),
            invalidatesTags: ['Showrooms'],
        }),
        addShowroom: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.SHOWROOMS,
                method: "POST",
                body: data,
                headers: {
                    "x-portal": "admin"
                }
            }),
            invalidatesTags: ["Showrooms"],
        }),
        deleteShowroom: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.SHOWROOMS}${id}`,
                method: "DELETE",
                headers: {
                    "x-portal": "admin"
                }
            }),
            invalidatesTags: ["Showrooms"],
        }),
        exportShowrooms: builder.mutation({
            query: () => ({
                url: ENDPOINTS.EXPORT_SHOWROOMS,
                method: 'GET',
                headers: {
                    'x-portal': 'admin'
                }
            }),
        }),
    }),
    overrideExisting: false,
});

export const { 
    useGetShowroomsQuery, 
    useGetShowroomByIdQuery,
    useUpdateShowroomMutation, 
    useAddShowroomMutation, 
    useDeleteShowroomMutation,
    useExportShowroomsMutation
} = showroomApi;
